import config from "../config";
import APIController from "./APIController";

class UserController{


    static TYPES = {
        ADMIN: 'admin',
        INSTRUCTOR: 'instructor',
        TRAINEE: 'trainee',
        POWER_INSTRUCTOR: 'powerInstructor',
        SUPERVISOR: 'supervisor'
    }


    static getMeinBauABCHomeUrl(){
        return config.TEILNEHMERPORTAL_URL;
    }

    static getPortfolioCourseURL(traineeId,courseId){
        return config.TEILNEHMERPORTAL_URL+"/mitarbeiter/UNI_"+traineeId+"/kurs/UNI_"+courseId;
    }

 
    static getPortfolioURL(traineeId){
        return config.TEILNEHMERPORTAL_URL+"/mitarbeiter/UNI_"+traineeId;
    }

    static getUsertypeNameByUserType(userType){
        switch(userType){
            case UserController.TYPES.ADMIN:
                return "Administrator";
            case UserController.TYPES.INSTRUCTOR:
                return "Ausbilder";
            case UserController.TYPES.POWER_INSTRUCTOR:
                return "Ausbilder (Power-User)";
            case UserController.TYPES.TRAINEE:
                return "Auszubildender";
            case UserController.TYPES.SUPERVISOR:
                return "Supervisor"; 
            default:
                throw new Error("unknow usertype");
        }
    }

    static isSupervisor(){
        try{
            if(UserController.getUser() == null){
                return false;
            }
            return UserController.getUser().type === this.TYPES.SUPERVISOR || UserController.getUser().type === this.TYPES.SUPERVISOR;
        }catch (e) {
            return false;
        }
    }

    static isInstructor(){
        try{
            if(UserController.getUser() == null){
                return false;
            }
            return UserController.getUser().type === this.TYPES.INSTRUCTOR || UserController.getUser().type === this.TYPES.POWER_INSTRUCTOR;
        }catch (e) {
            return false;
        }
    }

    static isTrainee(){
        try{
            if(UserController.getUser() == null){
                return false;
            }
            return UserController.getUser().type === this.TYPES.TRAINEE;
        }catch (e) {
            return false;
        }
    }

    static isAdmin(){
        try{
            if(UserController.getUser() == null){
                return false;
            }
            return UserController.getUser().type === this.TYPES.ADMIN;
        }catch (e) {
            return false;
        }
    }


    static isInstructorAdmin(){
        try{
            if(UserController.getUser() == null){
                return false;
            }
            return UserController.getUser().type === this.TYPES.POWER_INSTRUCTOR;
        }catch (e) {
            return false;
        }
    }

    static setLoggedinUser(userType, email, id){
        let loggedInUser = JSON.parse(localStorage.getItem('loggedInUser'));
        if(loggedInUser){
            loggedInUser.type = userType;
            loggedInUser.email = email;
            loggedInUser.id = id;
        localStorage.setItem('loggedInUser', JSON.stringify(loggedInUser));
        }else{
            window.alert("error while set login")
        }
    }

    static loginLocalUser(user, redirect=true){

        localStorage.setItem('loggedInUser', JSON.stringify(user));
        if(redirect){
            switch (user.type){
                case this.TYPES.ADMIN:
                    window.location = UserController.getMyProfileUrl();
                    break;
                case this.TYPES.INSTRUCTOR:
                    window.location = UserController.getMyCoursesUrl();
                    break;
                case this.TYPES.POWER_INSTRUCTOR:
                    window.location = UserController.getMyCoursesUrl();
                    break;
                case this.TYPES.TRAINEE:
                    window.location = UserController.getUsersHomeUrl();
                    break;
                default:
                    window.location = UserController.getMyProfileUrl();
            }
        }

    }


    static logout(){
        localStorage.clear();
        sessionStorage.clear();

        //setTimeout(function(){ window.location = "/"; }, 100);
    }

    static getMyCoursesUrl(){
        let user = UserController.getUser();

        if(user.type === this.TYPES.INSTRUCTOR){
            return "/instructor/"+user.id+"/courses";
        }else if(user.type === this.TYPES.POWER_INSTRUCTOR){
            return "/instructor/"+user.id+"/courses";
        }else if(user.type === this.TYPES.TRAINEE){
            return "/ltb/digitales-arbeitsblatt/meine-projekte";
        } else if(user.type === this.TYPES.ADMIN){
            return "/courses";
        }
        else{
            UserController.logout();
            throw new Error('unknown user and userType');
        }
    }

    static getMyProfileUrl(){
        let user = UserController.getUser();
        if(user.type === this.TYPES.INSTRUCTOR){
            return "/instructor/"+user.id+"/profile";
        }else if(user.type === this.TYPES.POWER_INSTRUCTOR){
            return "/instructor/"+user.id+"/profile";
        }else if(user.type === this.TYPES.TRAINEE){
            return "/trainee/"+user.id+"/profile";
        }else if(user.type === this.TYPES.SUPERVISOR){
            return config.TEILNEHMERPORTAL_URL+"/profil";
        }else if(user.type === this.TYPES.ADMIN){
            return "/profile";
        } else{
            UserController.logout();
            throw new Error('unknown user and userType');
        }
    }

    static getMyBauABCTraineeProfileUrl(userId){
        return config.TEILNEHMERPORTAL_URL+"/mitarbeiter/UNI_"+userId+"/profil";
    }

    static getUsersHomeUrl(){
        let user = UserController.getUser();
        if(user.type === this.TYPES.INSTRUCTOR){
            return "/instructor/"+user.id+"/courses";
        }else if(user.type === this.TYPES.POWER_INSTRUCTOR){
            return "/instructor/"+user.id+"/courses";
        }else if(user.type === this.TYPES.TRAINEE){
            return "/meine-projekte";
        }else if(user.type === this.TYPES.SUPERVISOR){
            return "/supervisor/"+user.id+"/profile";
        }else if(user.type === this.TYPES.ADMIN){
            return "/admin/"+user.id+"/worksheets";
        }else{
            UserController.logout();
            throw new Error('unknown user and userType');
        }
    }

    static isLoggedIn(){
        let user = UserController.getUser();
        return (user !== null && user !== undefined);
    }

    static async loginAs(userId){
        try{
            let newSessionUser = await APIController.loginAs(userId);
            UserController.setLoggedinUser(newSessionUser.type, newSessionUser.email, newSessionUser.id);
            return newSessionUser;
        }catch (e) {
            return null;
        }
    }

    static async switchLoginUser(userId){
        try{
            let newSessionUser = await APIController.switchLogin(userId);
            UserController.loginLocalUser(newSessionUser,
                    true
                );
                return newSessionUser;
        }catch (e) {
            return null;
        }
    }



    static getKeycloakUpdatePasswordUrl(){
        const redirectUri = encodeURIComponent(config.APP_HOST_URL);
        const keycloakUrl = config.KEYCLOAK_URL+`/realms/`+config.KEYCLOAK_REALM+`/protocol/openid-connect/auth?` +
                            `client_id=${config.KEYCLOAK_CLIENT_ID}&` +
                            `redirect_uri=${redirectUri}&` +
                            `response_type=code&`+
                            `scope=openid&`+
                            `kc_action=UPDATE_PASSWORD`;
        return keycloakUrl;
    }

    static getKeycloakLoginURL() {
        let currentPathAndQuery = window.location.pathname+window.location.search;
        const redirectUri = encodeURIComponent(config.KEYCLOAK_AUTH_CALLBACK+"?path="+currentPathAndQuery);
        const keycloakUrl = config.KEYCLOAK_URL+`/realms/`+config.KEYCLOAK_REALM+`/protocol/openid-connect/auth?` +
                            `client_id=${config.KEYCLOAK_CLIENT_ID}&` +
                            `redirect_uri=${redirectUri}&` +
                            `response_type=code&scope=openid`;
        return keycloakUrl;
    }

    static async loginUniPlusUserByCredentials(username,password){
        try{
            const params = new URLSearchParams();
            params.append("username", username);
            params.append("password", password);
            let response = await fetch(config.API_HOST_URL + "/users/unipluslogin?"+params.toString());
            if (!response.ok) {
                return null;
            }else{
                return await response.json();
            }
        }catch (e) {
            return null;
        }
    }

    static createLocalUser(sessionToken, type, email, id){
        return {
            'sessionToken': sessionToken,
            'type': type,
            'email': email,
            'id': id
        }
    }

    static getUser(){
        return JSON.parse(localStorage.getItem('loggedInUser'));
    }
}
export default UserController;